<template>
<div>
        <v-row no-gutters>
            
            <v-spacer/>
            <span style="width: 200px;" class="ma-2">
                    <!-- <v-autocomplete 
                         v-model="payment_type"
                        :items="types"
                    /> -->
            </span>
        </v-row>
        <div class="ml-4">PAYMENTS</div>
        <v-data-table
        :headers="headers"
        dense
        class="va-table"
        :items="summaries"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                        <td class="text-xs-left">{{ item.customer }}</td>
                        
                         <td class="text-right">{{ $money(item.paid_amount) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-right" style="border-top: 1px solid #212121;">TOTAL</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>
</div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
        type: String,
        default: ''
    }
  },
   data: () => ({
      summaries: [],
      formated_summaries:[],
      payment_type: "ALL",
      types:["ALL","CASH", "CREDIT"],
      headers: [
            { text: 'Customer'},
            { text: 'Paid Amount', align:"right" , sortable: false}
      ]
  }),
  created(){
       this.getItems()
  },
  computed:{
   
      TOTAL(){
          return this.summaries.reduce((res, item) => res += this.$IsNum(item.paid_amount), 0)
      }
  },
  methods: {
       getItems: function() {
         this.summaries = []
            this.$http.post("transaction/query_cashier_payments", {start_date: this.selected_date}).then(response => {
                  response.data.items != null?this.summaries = response.data.items: this.summaries = []
                 // this.FormatData()
          }).catch(e => {
           console.log(e.data)
         })
      }
  }
}
</script>
